/* eslint-disable */
import PropTypes from 'prop-types';

/**
 * An address
 */
const address = PropTypes.shape({
  /**
   * The presented form of the address
   */
  displayName: PropTypes.string.isRequired,

  /**
   * The `id` of the address
   */
  id: PropTypes.string.isRequired,
});

const AddressEntityPropTypes = {
  /**
   * An address
   */
  address,
};

export default AddressEntityPropTypes;
